import { Grid,  Card, Button } from '@material-ui/core';
import React, {  useEffect, useState } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from 'react-redux';
import { BuscarOferente, ConsultarOferentes, eliminarOferente, guardarOferente } from '../../../../actions/compras/OferentesAction';
import TableGeneric from '../../../compartidos/abms/TableGeneric';
import LoadingBeforeViewData from '../../../compartidos/LoadingBeforeViewData';
import BuscadorAbm from '../../../compartidos/abms/BuscadorAbm';
import FormOferentesFormulario from './FormOferentesFormulario';
import ModalAbm from '../../../compartidos/abms/ModalAbm';
import AccionesGenericoAbm from '../../../compartidos/abms/AccionesGenericoAbm';
import { OFERENTES_PERMISOS } from '../../../../utils/permisos';

const useStyles = makeStyles({
    root: {
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "1rem"
    }
});

const OferentesScreen = () => {

    const classes = useStyles();
    const dispatch = useDispatch();
    const {oferentesAbm} = useSelector((state) => state.compras);
    const [open, setOpen] = useState(false);
    const [oferente, setOferente] = useState(false);
    const [openAlta, setOferenteAlta] = useState(false);

    const handleSearch = (textoBuscado) => {
        
        dispatch(BuscarOferente(textoBuscado));
    }

    const handleSave = (item) => {
            dispatch(guardarOferente(item.idOferente, item));
    }

    const handleDelete = (item) => {
        dispatch(eliminarOferente(item.idOferente))
    }

    const handleOferenteSelect = (item) => {
        setOferente(item)
        setOpen(true)
      }
    useEffect(() => {
        dispatch(ConsultarOferentes())
    }, [dispatch])

    if(oferentesAbm === null){
        return <LoadingBeforeViewData />
    }
console.log(oferentesAbm)
    return(
        <div>
        <Grid container justify="center">
          <ModalAbm title="Agregar Oferente" open={openAlta} setOpen={setOferenteAlta}>
            <FormOferentesFormulario  oferentes={oferentesAbm} oferente={null} handleSave={handleSave} cerrarModal={() => setOferenteAlta(false)} permisoAlta={OFERENTES_PERMISOS.OFERENTES_ALTA}/>
          </ModalAbm>
          <ModalAbm title="Modificar Oferente" open={open} setOpen={setOpen}>
            <FormOferentesFormulario  oferentes={null} oferente={oferente} handleSave={handleSave} cerrarModal={() => setOpen(false)} permisoEdit={OFERENTES_PERMISOS.OFERENTES_MODIFICAR}/>
          </ModalAbm>
          <Grid item xs={12}>
            <Button variant="contained" color="primary" onClick={() => setOferenteAlta(true)} style={{ float: "right", marginTop: "1rem" }}>+ Agregar Oferente</Button>
          </Grid>
          <Grid item xs={12} md={6} className={classes.root}>
            <BuscadorAbm title="Buscar Oferente" handleSearch={handleSearch} />
          </Grid>
          <Grid item xs={12} md={9} style={{ marginTop: "2rem" }} >
            <Card>
              <TableGeneric
                data={oferentesAbm}
                columns={[
                  {
                    label:"",
                    customBody:(item) => (
                      <AccionesGenericoAbm
                        item={item}
                        handleItemSelect={handleOferenteSelect}
                        permisoDelete={OFERENTES_PERMISOS.OFERENTES_BAJA}
                        handleDelete={handleDelete}
                      />
                    )
                  },
                  {
                    label: "ID",
                    id: "idOferente",
                    sort: true
                },
                {
                    label: "Cuit",
                    id: "cuit",
                    sort: false
                },
                {
                    label: "Razón Social",
                    id: "razonSocial"
                },
                {
                    label: "Email",
                    id: "mail"
                },
                {
                  label: "Mails adicionales",
                  id:"emailsOferentes.email",
                  customBody: (item) =>
                    ` ${item?.emailsOferentes?.map(a=>a.email)} `
                }
                ]}
              />
            </Card>
          </Grid>
        </Grid>
      </div>
    );
};


export default OferentesScreen;